import { useState } from 'react'
import { Button, Typography } from '@mui/material'
import { useSelector } from 'react-redux';
import MasterPrivilegios from './masterPrivilegios';
import GenericosPrivilegios from './genericosPrivilegios';
import SessoesPrivilegios from './sessoesPrivilegios';
import EstabelecimentosPrivilegios from './estabelecimentosPrivilegios';
import EmpresasPrivilegios from './empresasPrivilegios';
import RepresentantesPrivilegios from './representantesPrivilegios';
import DirectorTecnicoPrivilegios from './directorTecnicoPrivilegios';
import LicenciamentoPrivilegios from './licenciamentoPrivilegios';
import ProdutosControladosPrivilegios from './produtosControladosPrivilegios';
import ImportacaoPrivilegios from './importacaoPrivilegios';
import DesalfandegamentoPrivilegios from './desalfandegamentoPrivilegios';
import ControloQualidadePrivilegios from './controloQualidadePrivilegios';
import AgendaPrivilegios from './agendaPrivilegios';
import MedicamentosPrivilegios from './medicamentosPrivilegios';
import GerenciardorSitePrivilegios from './gerenciadorSitePrivilegios';
import GerenciadorAdminPrivilegios from './gerenciadorAdminPrivilegios';
import FarmacovigilanciaPrivilegios from './farmacovigilanciaPrivilegios';
import ExpedientePrivilegios from './expedientePrivilegios';
import RelatoriosPrivilegios from './relatoriosPrivilegios';

export default function GerenciarPrivilegios({ cancelEditPrivilegios, user }) {
    const [permissions, setPermissions] = useState(user?.permissions)
    const userLogado = useSelector(state => state.account.user);

    return (
        <div>
            <Typography variant='h4'>
                Gerenciar Privilégios
            </Typography>

            {(userLogado?.funcao === "Director Geral" || userLogado?.funcao === "CNP") &&
                <MasterPrivilegios user={user} permissions={permissions} setPermissions={setPermissions} />
            }

            <GenericosPrivilegios user={user} permissions={permissions} setPermissions={setPermissions} />

            <SessoesPrivilegios user={user} permissions={permissions} setPermissions={setPermissions} />

            <EstabelecimentosPrivilegios user={user} permissions={permissions} setPermissions={setPermissions} />

            <EmpresasPrivilegios user={user} permissions={permissions} setPermissions={setPermissions} />

            <RepresentantesPrivilegios user={user} permissions={permissions} setPermissions={setPermissions} />

            <DirectorTecnicoPrivilegios user={user} permissions={permissions} setPermissions={setPermissions} />

            <LicenciamentoPrivilegios user={user} permissions={permissions} setPermissions={setPermissions} />

            <ImportacaoPrivilegios user={user} permissions={permissions} setPermissions={setPermissions} />

            <ProdutosControladosPrivilegios user={user} permissions={permissions} setPermissions={setPermissions} />

            <DesalfandegamentoPrivilegios user={user} permissions={permissions} setPermissions={setPermissions} />

            <ControloQualidadePrivilegios user={user} permissions={permissions} setPermissions={setPermissions} />

            <FarmacovigilanciaPrivilegios user={user} permissions={permissions} setPermissions={setPermissions} />

            <ExpedientePrivilegios user={user} permissions={permissions} setPermissions={setPermissions} /> 

            <AgendaPrivilegios user={user} permissions={permissions} setPermissions={setPermissions} />

            <MedicamentosPrivilegios user={user} permissions={permissions} setPermissions={setPermissions} />

            <GerenciardorSitePrivilegios user={user} permissions={permissions} setPermissions={setPermissions} />

            <GerenciadorAdminPrivilegios user={user} permissions={permissions} setPermissions={setPermissions} />
            
            <RelatoriosPrivilegios user={user} permissions={permissions} setPermissions={setPermissions} />


            <Button onClick={() => cancelEditPrivilegios(false)} color="warning" size="small" style={{ marginTop: 20, marginRight: 10 }}>Fechar</Button>
        </div>
    )
}
